import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Leaflet from 'leaflet';
import { TripImportComponent } from '../components/trip-import/trip-import.component';
import { OverlayRef } from '@angular/cdk/overlay-module.d';

@Injectable()
export class MapTripImportService implements OnDestroy {
  private translate = inject(TranslateService);
  private overlay = inject(Overlay);

  private overlayRef: OverlayRef | undefined;

  addTripImportControl(map: Leaflet.Map): void {
    const tripImportButton = Leaflet.Control.extend({
      options: {
        position: 'topright',
        title: this.translate.instant('General.SelectTripsForImport'),
        onClick: () => {
          if (this.overlayRef) return;
          this.openTripImportOverlay(map);
        },
        iconHtml: '<span class="dv-icons">trip</span>',
      },

      onAdd() {
        const container = Leaflet.DomUtil.create(
          'div',
          'leaflet-bar leaflet-control import-trips-control'
        );

        const button = Leaflet.DomUtil.create('a', '', container);
        button.href = '#';
        button.title = this.options.title;
        button.setAttribute('role', 'button');
        button.innerHTML = this.options.iconHtml;

        Leaflet.DomEvent.disableClickPropagation(button);
        Leaflet.DomEvent.disableScrollPropagation(button);

        Leaflet.DomEvent.on(button, 'click', e => {
          Leaflet.DomEvent.stop(e);
          this.options.onClick();
        });

        return container;
      },
    });

    const tripImportControl = new tripImportButton();
    tripImportControl.addTo(map);
  }

  ngOnDestroy(): void {
    this.destroyOverlay();
  }

  destroyOverlay = (): void => {
    this.overlayRef?.dispose();
    this.overlayRef?.detach();
    this.overlayRef = undefined;
  };

  private openTripImportOverlay(map: Leaflet.Map): void {
    if (this.overlayRef) return;
    const positionStrategy = this.overlay
      .position()
      .global()
      .top('var(--dv-spacing-100')
      .left('var(--dv-spacing-100');

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: false,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      panelClass: 'map-cdk-overlay',
    });

    const ref = this.overlayRef.attach(
      new ComponentPortal(TripImportComponent)
    );
    ref.setInput('map', map);
    ref.setInput('overlayDisposeFn', this.destroyOverlay);
  }
}
